import React from "react";
import Blocker from "../../../../Misc/Blocker";
import Context from "../../../../../Context";

import TreeView from "@material-ui/lab/TreeView";
import TreeItem from "@material-ui/lab/TreeItem";
import Scrollpane from "../../../../Misc/Scrollpane";

export default class WorkflowTree extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      pending: false,
      items: {},
      expanded: [],
      selected: props.activeItem ? [props.activeItem] : [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.textSearchValue !== this.props.textSearchValue) {
      this.load();
    }
  }
  load = async () => {
    const { textSearchValue } = this.props;

    this.setState({ pending: true });
    let result = false;
    let expanded = [];

    let items = {};
    let search = [];
    if (textSearchValue) {
      search.push({
        lstr: "(",
        field: "label",
        compare: "IKE",
        value: `%${textSearchValue}%`,
      });
      search.push({
        condition: "OR",
        field: "code",
        compare: "IKE",
        value: `%${textSearchValue}%`,
        rstr: ")",
      });
    }

    result = await this.context.api.q("/workflow/class/list", { search });
    if (result !== false) {
      if (result["id"]) result = [result];
      if (Array.isArray(result)) {
        result.forEach((item) => {
          if (textSearchValue) {
            item.parent = null;
          }
          if (item.parent) expanded.push(String(item.parent));
          items[item.id] = item;
        });
      }
    }

    this.setState({ pending: false, items, expanded });
  };

  handleToggle = (event, nodeIds) => {
    this.setState((state) => {
      return { expanded: nodeIds };
    });
  };

  handleSelect = (event, nodeIds) => {
    event.preventDefault();
    this.setState({ selected: nodeIds });
    this.props.onChange(String(nodeIds));
  };

  getChildren = (itemId) => {
    let children = [];
    for (let id in this.state.items) {
      let item = this.state.items[id];
      if (item.parent === itemId) children.push(item);
    }
    return children;
  };

  render() {
    const renderTree = (item) => (
      <TreeItem
        onClick={() => {}}
        key={item.id}
        nodeId={String(item.id)}
        label={
          <div>
            {item.label}
            <div className="small text-muted">{item.code}</div>
          </div>
        }
        className="my-2"
        onLabelClick={(e) => e.preventDefault()}
      >
        {this.getChildren(item.id).map((item) => renderTree(item))}
      </TreeItem>
    );

    return (
      <>
        <Blocker on={this.state.pending}>
          <TreeView
            defaultCollapseIcon={<i className="fa fa-angle-down"></i>}
            defaultExpandIcon={<i className="fa fa-angle-right"></i>}
            expanded={this.state.expanded}
            selected={this.state.selected}
            onNodeToggle={this.handleToggle}
            onNodeSelect={this.handleSelect}
          >
            {Object.entries(this.state.items).map(([id, item]) =>
              !item.parent ? renderTree(item) : null
            )}
          </TreeView>
        </Blocker>
      </>
    );
  }
}
